import { init as initApm } from "@elastic/apm-rum";

let environment = window.location.host.split(".")[0].toUpperCase() || "fltest";
export const apm = initApm({
  // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
  serviceName: environment + "-NIO-APP",
  api_key: "QlV0bDY0UUJsQTN5MUd1ZmM0Nk06d0pGUHpvenlUb21XNnE0ZGVtUk5FZw==",
  // Set custom APM Server URL (default: http://localhost:8200)
  serverUrl: window.location.origin + "/apm",

  // Set service version (required for sourcemap feature)

  environment
});



// WEBPACK FOOTER //
// ./src/utils/elastic.js